import { useState, useEffect } from "react";
import { Sheet } from "react-modal-sheet";
import { Box, Grid, Typography, Switch } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Link from "next/link";

import DarkAndLightMode from "@/components/Layouts/ControlPanelModal/DarkAndLightMode";
import { useThemeMode } from "@/contexts/ThemeContext"; 

const PrivacySettingsSheet = ({ open, onClose }) => {
     const { isDarkMode } = useThemeMode(); 

	const [notificationsEnabled, setNotificationsEnabled] = useState(false);
	const [cameraPermission, setCameraPermission] = useState(false);

	// Request notification permission
	const handleNotificationsToggle = async (enabled) => {
		if (enabled) {
			try {
				const permission = await Notification.requestPermission();
				if (permission === "granted") {
					setNotificationsEnabled(true);
					// You can now subscribe to push notifications here
					console.log("Notification permission granted");
				} else {
					setNotificationsEnabled(false);
					console.log("Notification permission denied");
				}
			} catch (error) {
				console.error("Error requesting notification permission:", error);
				setNotificationsEnabled(false);
			}
		} else {
			setNotificationsEnabled(false);
			// Optionally unsubscribe from push notifications
		}
	};

	// Request camera permission
	const handleCameraToggle = async (enabled) => {
		if (enabled) {
			try {
				const stream = await navigator.mediaDevices.getUserMedia({ video: true });
				// Immediately stop the stream as we just needed permission
				stream.getTracks().forEach((track) => track.stop());
				setCameraPermission(true);
				console.log("Camera permission granted");
			} catch (error) {
				console.error("Error requesting camera permission:", error);
				setCameraPermission(false);
			}
		} else {
			setCameraPermission(false);
		}
	};

	return (
		<Sheet isOpen={open} onClose={onClose} snapPoints={[1]}>
			<Sheet.Container
				className={"sheet-bg " + (isDarkMode ? "dark" : "")}
				style={{
					borderTopLeftRadius: "0",
					borderTopRightRadius: "0",
					height: "100vh",
					maxHeight: "100vh",
					padding: "24px",
					boxSizing: "border-box",
				}}>
				<Sheet.Header />
				<Sheet.Content style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							marginBottom: "32px",
						}}>
						<div style={{ display: "flex", alignItems: "center" }}>
							<button
								onClick={onClose}
								style={{
									background: "none",
									border: "none",
									padding: 0,
									marginRight: 12,
									cursor: "pointer",
								}}>
								<ArrowBackIosNewIcon
									style={{ fontSize: 20, color: isDarkMode ? "#fff" : "#000" }}
								/>
							</button>
							<h2
								style={{
									margin: 0,
									fontSize: "20px",
									fontWeight: "600",
									color: isDarkMode ? "#fff" : "#000",
								}}>
								Setări de confidențialitate
							</h2>
						</div>
					</div>

					<Box className='glass-box' sx={{ flexGrow: 1 }}>
						<Typography variant='body2' sx={{ mb: 2, color: isDarkMode ? "#aaa" : "#666" }}>
							Administrați modul în care datele sunt utilizate de ALLConsulting. Pentru mai multe
							informații, citiți{" "}
							<span style={{ fontWeight: "bold" }}>
								<Link href='https://app.all-consulting-lascu.ro/politica-de-confidentialitate'>
									Politica de Confidențialitate
								</Link>{" "}
								,{" "}
								<Link href='https://app.all-consulting-lascu.ro/politica-cookies'>
									Politica de Cookie-uri
								</Link>
                                        {" "} si {" "}
                                        <Link href='https://app.all-consulting-lascu.ro/termeni-si-conditii'>
									Termeni si conditii
								</Link>
								.
							</span>
						</Typography>

						<Grid container spacing={3} sx={{ mt: 1 }}>
							{/* Notifications */}
							<Grid item xs={12}>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
									}}>
									<div style={{ display: "flex", alignItems: "center" }}>
										<NotificationsIcon
											sx={{
												mr: 2,
												color: isDarkMode ? "#fff" : "#000",
												fontSize: "24px",
											}}
										/>
										<div>
											<Typography component='label'>Notificări</Typography>
											<Typography
												variant='caption'
												sx={{
													display: "block",
													color: isDarkMode ? "#aaa" : "#666",
												}}>
												Permiteți aplicației să vă trimită notificări push
											</Typography>
										</div>
									</div>
									<Switch
										checked={notificationsEnabled}
										onChange={(e) => handleNotificationsToggle(e.target.checked)}
										color='primary'
									/>
								</div>
							</Grid>

							{/* Camera Permission */}
							<Grid item xs={12}>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
									}}>
									<div style={{ display: "flex", alignItems: "center" }}>
										<CameraAltIcon
											sx={{
												mr: 2,
												color: isDarkMode ? "#fff" : "#000",
												fontSize: "24px",
											}}
										/>
										<div>
											<Typography component='label'>Permisiunea camerei</Typography>
											<Typography
												variant='caption'
												sx={{
													display: "block",
													color: isDarkMode ? "#aaa" : "#666",
												}}>
												Vă permite să faceți o fotografie a semnăturii dvs
											</Typography>
										</div>
									</div>
									<Switch
										checked={cameraPermission}
										onChange={(e) => handleCameraToggle(e.target.checked)}
										color='primary'
									/>
								</div>
							</Grid>

                                   <Grid item xs={12}>
                                        <DarkAndLightMode />
                                   </Grid>
						</Grid>
					</Box>
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default PrivacySettingsSheet;
